import React from "react";
import { FiLoader } from 'react-icons/fi';
import { HiSparkles } from 'react-icons/hi';

const PersonalDetails = ({
  formData,
  handleChange,
  handleImproveDescription,
  isImproving,
}) => {
  return (
    <div className="space-y-5">
      {/* Page Headline */}
      <div>
        <label htmlFor="title" className="text-gray-200">Headline</label>
        <input
          id="title"
          type="text"
          name="title"
          value={formData.title || ''}
          onChange={handleChange}
          placeholder="e.g., Your Business Name"
        />
        <p className="text-xs text-gray-500 mt-1">This is the main title displayed on your home page</p>
      </div>

      {/* Description Textarea with AI Button */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
          <label htmlFor="description" className="text-gray-200" style={{ margin: 0 }}>Tagline / Description</label>
          <button
            type="button"
            onClick={handleImproveDescription}
            disabled={isImproving}
            title="Enhance with AI"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '5px 10px',
              fontSize: '12px',
              fontWeight: 500,
              borderRadius: '6px',
              border: 'none',
              background: isImproving
                ? '#334155'
                : 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 50%, #3b82f6 100%)',
              color: '#ffffff',
              cursor: isImproving ? 'not-allowed' : 'pointer',
              opacity: isImproving ? 0.7 : 1,
              transition: 'all 0.2s ease',
              boxShadow: isImproving ? 'none' : '0 2px 8px rgba(99, 102, 241, 0.3)',
            }}
          >
            {isImproving ? (
              <>
                <FiLoader className="animate-spin" style={{ width: '14px', height: '14px' }} />
                <span>Improving...</span>
              </>
            ) : (
              <>
                <HiSparkles style={{ width: '14px', height: '14px' }} />
                <span>AI Enhance</span>
              </>
            )}
          </button>
        </div>
        <textarea
          id="description"
          name="description"
          value={formData.description || ''}
          onChange={handleChange}
          rows="3"
          placeholder="Your tagline or short description..."
          className="resize-none"
        />
        <p className="text-xs text-gray-500 mt-1">For bullet points with icons, use Feature Highlights below</p>
      </div>

      {/* CTA Button Section */}
      <div style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)',
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid #8b5cf6'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <div style={{ padding: '8px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '8px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
          </div>
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#ffffff', margin: 0 }}>Call-to-Action Button</h3>
            <p style={{ fontSize: '12px', color: '#e9d5ff', margin: 0 }}>Add a phone number button to your home page</p>
          </div>
        </div>

        {/* Phone Number Input */}
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', fontSize: '13px', color: '#ffffff', marginBottom: '6px', fontWeight: '600' }}>
            Phone Number
          </label>
          <input
            type="text"
            name="cta_phone"
            value={formData.cta_phone || ''}
            onChange={handleChange}
            placeholder="e.g., +91 82200 32701"
            style={{
              width: '100%',
              padding: '12px 14px',
              fontSize: '15px',
              backgroundColor: '#0f172a',
              border: '1px solid #475569',
              borderRadius: '8px',
              color: '#fff',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Color Pickers */}
        <div style={{ display: 'flex', gap: '16px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '13px', color: '#ffffff', marginBottom: '6px', fontWeight: '600' }}>
              Button Color
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                type="color"
                name="cta_bg_color"
                value={formData.cta_bg_color || '#fbbf24'}
                onChange={handleChange}
                style={{
                  width: '50px',
                  height: '40px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              />
              <input
                type="text"
                value={formData.cta_bg_color || '#fbbf24'}
                onChange={(e) => handleChange({ target: { name: 'cta_bg_color', value: e.target.value } })}
                style={{
                  flex: 1,
                  padding: '10px',
                  fontSize: '13px',
                  backgroundColor: '#0f172a',
                  border: '1px solid #475569',
                  borderRadius: '8px',
                  color: '#fff',
                  fontFamily: 'monospace'
                }}
              />
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '13px', color: '#ffffff', marginBottom: '6px', fontWeight: '600' }}>
              Text Color
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                type="color"
                name="cta_text_color"
                value={formData.cta_text_color || '#000000'}
                onChange={handleChange}
                style={{
                  width: '50px',
                  height: '40px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              />
              <input
                type="text"
                value={formData.cta_text_color || '#000000'}
                onChange={(e) => handleChange({ target: { name: 'cta_text_color', value: e.target.value } })}
                style={{
                  flex: 1,
                  padding: '10px',
                  fontSize: '13px',
                  backgroundColor: '#0f172a',
                  border: '1px solid #475569',
                  borderRadius: '8px',
                  color: '#fff',
                  fontFamily: 'monospace'
                }}
              />
            </div>
          </div>
        </div>

        {/* Preview */}
        {formData.cta_phone && (
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: '#0f172a', borderRadius: '8px' }}>
            <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '12px' }}>Preview:</p>
            <div style={{ textAlign: 'center' }}>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 24px',
                  backgroundColor: formData.cta_bg_color || '#fbbf24',
                  color: formData.cta_text_color || '#000000',
                  borderRadius: '9999px',
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                {formData.cta_phone}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalDetails;